import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 py-4 transition-all duration-300 ${
        isScrolled ? 'bg-black/80 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/">
              <Logo />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-12">
            <Link to="/services" className="text-white text-sm font-medium hover:text-red-500 transition-colors">
              SERVICES
            </Link>
            <Link to="/client-results" className="text-white text-sm font-medium hover:text-red-500 transition-colors">
              CLIENT RESULTS
            </Link>
            <Link to="/about" className="text-white text-sm font-medium hover:text-red-500 transition-colors">
              ABOUT
            </Link>
            <Link to="/contact" className="text-white text-sm font-medium hover:text-red-500 transition-colors">
              CONTACT
            </Link>
          </div>

          <div className="hidden md:flex items-center">
            <Link to="/contact" className="text-white text-sm font-medium hover:text-red-500 transition-colors">
              JOIN THE FAMILY
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={toggleMenu} className="text-white focus:outline-none">
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden bg-black mt-4 py-4 px-2 rounded-lg">
            <div className="flex flex-col space-y-4">
              <Link
                to="/services"
                className="text-white text-sm font-medium hover:text-red-500 transition-colors px-2 py-1"
                onClick={() => setIsMenuOpen(false)}
              >
                SERVICES
              </Link>
              <Link
                to="/client-results"
                className="text-white text-sm font-medium hover:text-red-500 transition-colors px-2 py-1"
                onClick={() => setIsMenuOpen(false)}
              >
                CLIENT RESULTS
              </Link>
              <Link
                to="/about"
                className="text-white text-sm font-medium hover:text-red-500 transition-colors px-2 py-1"
                onClick={() => setIsMenuOpen(false)}
              >
                ABOUT
              </Link>
              <Link
                to="/contact"
                className="text-white text-sm font-medium hover:text-red-500 transition-colors px-2 py-1"
                onClick={() => setIsMenuOpen(false)}
              >
                CONTACT
              </Link>
              <hr className="border-gray-700" />
              <Link
                to="/contact"
                className="text-white text-sm font-medium hover:text-red-500 transition-colors px-2 py-1"
                onClick={() => setIsMenuOpen(false)}
              >
                JOIN THE FAMILY
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;